module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.$auth.hasRole(['COMPANY_ADMIN', 'COMPANY_USER'], true)) ? _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n          " + _vm._s(_vm.$t('dashboard.lastRecordings')) + "\n        ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('records', {
    attrs: {
      "paginating": false,
      "filtering": false,
      "exportable": false,
      "perPage": 6
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/recordings",
      "ř": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('dashboard.moreRecordings')))])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$auth.hasRole(['SUPER_ADMIN', 'COMPANY_ADMIN', 'GROUP_ADMIN'])) ? _c('v-flex', {
    staticClass: "my-2"
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('dashboard.notifications')))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('notifications', {
    attrs: {
      "small": true
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$auth.hasRole('SUPER_ADMIN')) ? _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('dashboard.systemStorageUsage')))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('system-storage-report', {
    attrs: {
      "small": true
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$auth.hasRole(['GROUP_ADMIN', 'COMPANY_ADMIN'])) ? _c('v-flex', {
    class: {
      'my-2': true, xs3: _vm.$auth.hasRole('COMPANY_ADMIN'), xs4: _vm.$auth.hasRole('GROUP_ADMIN')
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('dashboard.logicStorageUsage')))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('logic-storage-report', {
    attrs: {
      "small": true,
      "size": _vm.$auth.hasRole('GROUP_ADMIN') ? 300 : 250
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75bbb733","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard.vue
// module id = 1086
// module chunks = 1